export default {
  documentTitle:
    'ハードウェアウォレット - あなたの鍵のパートナー、暗号資産を守る | KeyPal',
  product: '製品',
  learn: '学習',
  support: 'サポート',
  others: 'その他',
  language: '言語',
  forBusiness: '法人向け',
  apps: 'アプリ',
  secretBox: 'Secret Box',
  learnMore: 'もっと詳しく見る', 
  goShoppingCart: 'ストアへ行く', 
  contactUs: 'お問い合わせ:', 
  tutorials: 'チュートリアル', 
  mobileWallet: 'モバイルウォレット', 
  extensionWallet: '拡張機能ウォレット', 
  cases: 'ケーススタディ:', 
  cooperationSolution: '/ 協業プラン', 
  information: '情報', 
  security: 'あんぜん', 
  darkMode: 'ダークモード',
  KeyPal_2_firmware: 'KeyPal 2 ファームウェア', 
  KeyPal_Plus_firmware: 'KeyPal Plus ファームウェア', 
  more: 'さらにその他...',
  comingSoon: '近日公開',
}
